// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class String implements flatbuffers.IUnpackableObject<StringT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): String {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsString(bb: flatbuffers.ByteBuffer, obj?: String): String {
    return (obj || new String()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsString(bb: flatbuffers.ByteBuffer, obj?: String): String {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new String()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): string;
  value(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  value(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startString(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, valueOffset, 0);
  }

  static endString(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // value
    return offset;
  }

  static createString(
    builder: flatbuffers.Builder,
    valueOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    String.startString(builder);
    String.addValue(builder, valueOffset);
    return String.endString(builder);
  }

  unpack(): StringT {
    return new StringT(this.value());
  }

  unpackTo(_o: StringT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): StringT {
    const t = new StringT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class StringT implements flatbuffers.IGeneratedObject {
  constructor(public value: string | Uint8Array | null = null) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.value === null || this.value === undefined) {
      throw new Error('Required field "value" is not set');
    }
    const value = this.value !== null ? builder.createString(this.value!) : 0;

    return String.createString(builder, value);
  }

  clone(): StringT {
    const obj = new StringT();
    obj.value = this.value;
    return obj;
  }

  equals(other: StringT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyString(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "value");
  } finally {
    verifier.popDepth();
  }
}
